import axios from "axios";
import html2pdf from "html2pdf.js";
import ReactDOMServer from "react-dom/server";
import { message } from "antd";
import dayjs from "dayjs";

const apiUrl = process.env.REACT_APP_API_URL;

export const get_bank_accounts = async (token, company_id, type_search, extra = {}) => {
	try {
		const body = {
			token,
			company_id,
			type_search,
			extra,
		};

		const res = await axios.post(`${apiUrl}/get_bank_accounts`, body);
		if (res.status === 200) return res.data;
		message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};

export const edit_bank_account = async (token, edit_value, data) => {
	try {
		const body = {
			token,
			edit_value,
			data,
		};

		const res = await axios.post(`${apiUrl}/edit_bank_accounts`, body);
		if (res.status === 200 || res.status === 201) return res.data;
		message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};

export const get_bank_transactions = async (token, type_search, data = {}) => {
	try {
		const body = {
			token,			
			type_search,
			data,
		};

		const res = await axios.post(`${apiUrl}/get_bank_transactions`, body);
		if (res.status === 200 || res.status === 201) return res.data;
		message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};

export const edit_bank_transactions = async (token, edit_value, data) => {
	try {
		const body = {
			token,
			edit_value,
			data,
		};

		const res = await axios.post(`${apiUrl}/edit_bank_transactions`, body);
		if (res.status === 200 || res.status === 201) return res.data;
		message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};

// ! =====================================================================================
// ! BANK RECONCILIATION =================================================================
// ! =====================================================================================

export const bank_reconciliation_manager = async(token, consult_type, data) => {
	try {
		const body = {
			token,
			consult_type,
			data,
		};
		const res = await axios.post(`${apiUrl}/bank_reconciliation_manager`, body);
		if (res.status === 200) return res.data;
		message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};

// ! =====================================================================================
// ! GENERATE REPORTS ====================================================================
// ! =====================================================================================

export async function generate_bank_account_report(
	dataMatrix, 
	company, 
	nameFile,
	currencyType = "GTQ",
	renderContent = null
){
	if(dataMatrix == null){
		message.error("Developer Error: You didn't set a invoice in the method generate invoice pdf");
	}
	
	if(renderContent == null){
		message.error("Developer Error: You didn't set a Render Invoice Content");
	}

	const htmlContent = ReactDOMServer.renderToStaticMarkup(renderContent(dataMatrix));

	const tempDiv = document.createElement("div");
	tempDiv.style.overflow = "visible";
	tempDiv.innerHTML = htmlContent;
	document.body.appendChild(tempDiv);
	
	const today = dayjs(new Date());
	const todayFormatted = today.format("YYYY-MM-DD HH:mm:ss");
	const fileName = `_BANK_ACCOUNT_REPORT_${nameFile}_${currencyType}_FROM_COMPANY_${company?.tid}_${todayFormatted}`;
                                                    
	const opt = {
		margin: [0.2, 0.2, 0.2, 0.2],
		filename: `${fileName}.pdf`,
		image: { type: "jpeg", quality: 0.98 },
		html2canvas: { 
			scale: 2, 
			useCORS: true,
		},
		jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
	};	

	await html2pdf().from(tempDiv).set(opt).save();
	
	document.body.removeChild(tempDiv);

	message.success("PDF generado y descargado exitosamente.");
}
